import React, { useEffect } from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
import ContactSection from '../HomePage/ContactSection'
import NewsLetter from '../HomePage/NewsLetter'
import PhotoGallery from './PhotoGallery'

function PhotoGalleryIndex() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <PhotoGallery />
      <Footer />
      <ContactSection />
      <NewsLetter />
    </div>
  )
}

export default PhotoGalleryIndex
